

import React from 'react';
import { useState, useEffect } from 'react';
import './index.css';
import axios from "axios";
import { UserAddOutlined, PlusOutlined ,ExclamationCircleOutlined} from '@ant-design/icons';
import { Button } from 'antd';
import UserIcon from '../UserIcon.png' // No ReactComponent here
import { Modal, Form, Input, Select, Checkbox, notification, message } from "antd";
import { API_ENDPOINT_GET_CC_DATA, API_ENDPOINT_REMOVE_CC, API_ENDPOINT_VENDORS, API_ENDPOINT_GET_CCS, API_ENDPOINT_CC_DETAILS } from "../vendorfollowup.constants";
import EmailIcon from './Email.png'
import EmailUserIcon from './EmailUserIcon.png'
import MarkEmailReadOutlinedIcon from '@mui/icons-material/MarkEmailReadOutlined';
import AddCCModal from '../ScheduleFollowUps/AddCCModal';
import Loader from 'app/shared/Loader';
import { useNavigate } from 'react-router-dom';

const ContactPopup = ({ message, emoji, onClose }) => {


    return (
        <div className="popup-container">
            <div className="popup-content">
                <span className="popup-emoji">{emoji}</span>
                <p>{message}</p>
                <Button type="primary" onClick={onClose}>
                    Close
                </Button>
            </div>
        </div>
    );
};



const ScheduleCCFeature = ({ setShowDetails }) => {
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [rowData, setRowData] = useState([]);
    const [popupMessage, setPopupMessage] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [ccList, setCCList] = useState([])
    const [loading, setLoading] = useState(true);
    const [selectedVendors, setSelectedVendors] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [includeAllOptions, setIncludeAllOptions] = useState(false);
    const [vendorList, setVendorList] = useState(null)
    const [isModalVisible, setModalVisible] = useState(false);
    const [editData, setEditData] = useState(null);
    const [ccId, setccId] = useState(null)


    // const currentWorkspace = localStorage.getItem("currentWorkspace");
    const [currentWorkspace, setCurrentWorkspace] = useState(() => {
        return localStorage.getItem("currentWorkspace");
    });

    const fetchVendors = async () => {
        try {
            const response = await fetch(API_ENDPOINT_VENDORS, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ workspace: currentWorkspace }),
            });

            const data = await response.json();
            if (data.status === "success") {
                const formattedVendors = data.vendors.map((vendor) => ({
                    value: vendor,
                    label: vendor,
                }));

                // setVendorList((prev) => {
                //     const isSame =
                //         prev.length === formattedVendors.length &&
                //         prev.every((v, i) => v.value === formattedVendors[i].value);
                //     return isSame ? prev : formattedVendors;
                // });
                setVendorList(formattedVendors)
            }
        } catch (error) {
            console.error("Error fetching vendor data:", error);
        } finally {
            setLoading(false);
        }
    };
    const fetchCCList = async () => {
        setLoading(true);
        try {
            const response = await axios.post(API_ENDPOINT_CC_DETAILS, {
                workspaceid: currentWorkspace,
            });

            if (Array.isArray(response.data.data) && response.data.data.length > 0) {
                // setCCList(response.data.data);
                setCCList((prev) => {
                    const isSame = JSON.stringify(prev) === JSON.stringify(response.data.data);
                    return isSame ? prev : response.data.data;
                });
                console.log("Data in fetch cc list")
            } else {
                setCCList([]);
                console.log("No data");
            }
        } catch (error) {
            console.error("Error fetching CC list:", error);
            setCCList([]);
        }finally {
            setLoading(false); // Set loading to false after the fetch is complete
        }
    };

    useEffect(() => {

        if (!currentWorkspace) return;
        const fetchData = async () => {
            await fetchVendors();
            await fetchCCList();
        };

        fetchData();
    }, [currentWorkspace]);
    const handleEditClick = (ccData) => {
        console.log("Inside handle edit click")
        setEditData(ccData);       // sets the selected row's data
      setAddCCModalVisible(true);     // opens the modal
        setccId(ccData._id);        // assuming 'id' is the unique identifier for the CC
    };

    console.log(editData,"editData")





    // const handleViewMoreClick = () => {
    //     setShowDetails(true);
    // };
    const handleViewMoreClick = () => {
        navigate('/vendorfollowup/detailPage');
    };

    console.log(showModal, "showModal")
    const [isAddCCModalVisible, setAddCCModalVisible] = useState(false);

    const handleAddCCSuccess = (newRow) => {
        // Do something with the new row, e.g., update a table
        console.log("New CC Added:", newRow);
    };


    const handleRemoveCC = async (ccData) => {
        const authToken = localStorage.getItem("token");
        const currentWorkspace = localStorage.getItem("currentWorkspace");

        console.log("Workspace ID:", currentWorkspace);
        console.log("Email:", ccData.email);

        if (!authToken) {
            alert("Authentication token not found.");
            return;
        }

        try {
            // Assumes your new endpoint is '/remove-cc' and expects query params for workspace and email
            const response = await axios.delete(
                API_ENDPOINT_REMOVE_CC,
                {
                    headers: { Authorization: `Bearer ${authToken}` },
                    params: {
                        workspaceid: currentWorkspace,
                        email: ccData.email,
                    },
                }
            );

            if (response.data.status) {
                // Update the grid by filtering out the removed CC
                setCCList(prevList => prevList.filter(cc => cc.email !== ccData.email));
                // Optionally, show a success popup
                setPopupMessage("CC Removed Successfully!"); // Set remove success message
                setShowPopup(true);
            } else {
                console.error("Failed to remove CC: ", response.data.message);
            }
        } catch (error) {
            console.error("Error removing CC: ", error);
        }
    };

    const handleClick = (ccData) => {
        Modal.confirm({
            title: "Confirm Removal",
            content: "Are you sure you want to remove this vendor?",
            icon: <ExclamationCircleOutlined style={{ color: "#0A8394" }} />, // Custom icon color
            okText: "Yes",
            cancelText: "No",
            okButtonProps: {
                style: { backgroundColor: "#0A8394", color: "white", border: "none" },
            },
            cancelButtonProps: {
                style: { backgroundColor: "white", color: "#0A8394", border: "1px solid #0A8394" },
            },
            onOk: () => handleRemoveCC(ccData), // Calls handleRemoveCC function when 'Yes' is clicked
        });
    };

    return (
        <>
            {loading ? (
                  <div className="loading-container"  style={{
                    height: "60vh",          // Full viewport height
                    width: "40vw",           // Full viewport width
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}>
                   <Loader />
                    {/* You can replace the <p> with a spinner if you want */}
                </div>
                 
            ) : ccList?.length > 0 ? (
                <div className='ccDataPresent'>
                    <div className='ccHeading' style={{ padding: "0px" }}>
                        <div style={{ display: 'flex', gap: '35px' ,justifyContent:'space-between', width:'100%'}}>
                            <div style={{ display: 'flex' }}>
                                <div>
                                    <img className="emailImage" src={EmailIcon} />
                                </div>
                                <div style={{ marginLeft: '10px' }}>
                                    <div className='emailTextHeader'>Email CC Feature</div>
                                    <div className='emailTextHeader2'>Set & Control when mail to be sent.</div>
                                </div>
                            </div>
                            <div className='viewMore' onClick={handleViewMoreClick}>
                                View More
                            </div>
                        </div>
                    </div>
    
                    <ul className='ccList'>
                        {ccList.map((cc) => (
                            <div
                                key={cc._id}
                                className='ccItem'
                                style={{ display: 'flex', gap: '12px', marginBottom: '10px', alignItems: 'center' }}
                            >
                                {/* User Icon */}
                                <div className="user-icon" style={{ width: '32px', height: '32px', borderRadius: '50%', objectFit: 'cover', marginBottom: '15px' }}>
                                    <img
                                        src={EmailUserIcon}
                                        alt="User"
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            borderRadius: '50%',
                                            objectFit: 'cover',
                                        }}
                                    />
                                </div>
    
                                {/* User Details */}
                                <div className="user-details" style={{ flexDirection: 'column', justifyContent: "space-between", display: 'flex', width: '100%' }}>
                                    <div className='UserMain'>
                                        <div className="user-name">{cc?.name || ' '}</div>
                                        <div style={{ display: "flex", gap: "8px", cursor: 'pointer' }}>
                                            <div onClick={() => handleEditClick(cc)} style={{ cursor: 'pointer' }}>
                                                {/* Edit SVG */}
                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M5.83398 5.83343H5.00065C4.55862 5.83343 4.1347 6.00903 3.82214 6.32159C3.50958 6.63415 3.33398 7.05807 3.33398 7.5001V15.0001C3.33398 15.4421 3.50958 15.8661 3.82214 16.1786C4.1347 16.4912 4.55862 16.6668 5.00065 16.6668H12.5007C12.9427 16.6668 13.3666 16.4912 13.6792 16.1786C13.9917 15.8661 14.1673 15.4421 14.1673 15.0001V14.1668M13.334 4.16677L15.834 6.66677M16.9882 5.48759C17.3164 5.15938 17.5007 4.71424 17.5007 4.25009C17.5007 3.78594 17.3164 3.34079 16.9882 3.01259C16.6599 2.68438 16.2148 2.5 15.7507 2.5C15.2865 2.5 14.8414 2.68438 14.5132 3.01259L7.50065 10.0001V12.5001H10.0007L16.9882 5.48759Z" stroke="#0A8394" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </div>
                                            <div onClick={() => handleClick(cc)} style={{ cursor: 'pointer' }}>
                                                {/* Delete SVG */}
                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M3.33398 5.83333H16.6673M8.33398 9.16667V14.1667M11.6673 9.16667V14.1667M4.16732 5.83333L5.00065 15.8333C5.00065 16.2754 5.17625 16.6993 5.48881 17.0118C5.80137 17.3244 6.22529 17.5 6.66732 17.5H13.334C13.776 17.5 14.1999 17.3244 14.5125 17.0118C14.8251 16.6993 15.0007 16.2754 15.0007 15.8333L15.834 5.83333M7.50065 5.83333V3.33333C7.50065 3.11232 7.58845 2.90036 7.74473 2.74408C7.90101 2.5878 8.11297 2.5 8.33398 2.5H11.6673C11.8883 2.5 12.1003 2.5878 12.2566 2.74408C12.4129 2.90036 12.5007 3.11232 12.5007 3.33333V5.83333"
                                                        stroke="#0A8394"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
    
                                    {/* User Email */}
                                    <div className="user-email" style={{ display: "flex", gap: "8px" }}>
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <path d="M9.16667 15.8337H4.16667C3.72464 15.8337 3.30072 15.6581 2.98816 15.3455C2.67559 15.0329 2.5 14.609 2.5 14.167V5.83366M2.5 5.83366C2.5 5.39163 2.67559 4.96771 2.98816 4.65515C3.30072 4.34259 3.72464 4.16699 4.16667 4.16699H15.8333C16.2754 4.16699 16.6993 4.34259 17.0118 4.65515C17.3244 4.96771 17.5 5.39163 17.5 5.83366M2.5 5.83366L10 10.8337L17.5 5.83366M17.5 5.83366V10.8337M12.5 15.8337L14.1667 17.5003L17.5 14.167" stroke="#A3A6B7" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </div>
                                        <div>{cc.email}</div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </ul>
    
                    <AddCCModal
                        visible={isAddCCModalVisible}
                        onClose={() => setAddCCModalVisible(false)}
                        onSuccess={handleAddCCSuccess}
                        initialData={editData}
                        ccId={ccId}
                    />
                </div>
            ) : (
                <div className='leftportion'>
                    <div className='userIcon'>
                        <img src={UserIcon} alt="User Icon" style={{ width: '40px', height: '40px', borderRadius: '50%' }} />
                        <p className='para'>Keep Your team in the loop</p>
                        <p className='para2'>
                            Add teammates to the CC field so they stay updated without needing to take direct action.
                        </p>
                    </div>
                    <AddCCModal
                        visible={isAddCCModalVisible}
                        
                        onClose={() => {
                            setAddCCModalVisible(false);
                            setEditData(null); // <--- this is important
                          }}
                        onSuccess={handleAddCCSuccess}
                        initialData={editData}
                        ccId={ccId}
                    />
                </div>
            )}
        </>
    );
    
}

export default ScheduleCCFeature;

